import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

class CorkMartBuyboxDelivery extends Component {
  #controller;
  #generation = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.onVariant, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#generation++;
    super.disconnectedCallback();
  }

  onVariant = async (event) => {
    if (event.target.closest('product-card, quick-add-dialog')) return;
    const generation = ++this.#generation;
    const content = this.querySelector('[data-cm-delivery-content]');
    content.hidden = true;
    try {
      const { detail } = await event.promise;
      if (generation !== this.#generation || !this.isConnected || String(detail?.productId) !== this.dataset.productId) return;
      const source = detail.html?.querySelector('cm-buybox-delivery [data-cm-delivery-content]');
      if (source) {
        morph(content, source);
        content.hidden = false;
      }
    } catch {
      // No claim from a stale selection when the native variant request fails.
    }
  };
}

if (!customElements.get('cm-buybox-delivery')) customElements.define('cm-buybox-delivery', CorkMartBuyboxDelivery);
